import React, { useState } from "react"

import FuwfCard from "./FuwfCard"
import FuwfFooter from "./FuwfFooter"
import classes from "./index.module.scss"

const FumFiles = props => {
  const {
    files,
    setFiles,
    setTab,
    enableCrop,
    preserveOriginalFile,
    setOpenModal,
    originalFiles,
    maxFilesReached,
    maxNumberOfUploads,
    onUploadComplete,
    imageCategory,
    setSelectedFileForEdit
  } = props

  const [sending, setSending] = useState(false)

  return (
    <div className={classes["container"]}>
      <div className={classes["wrapper"]}>
        {files.map((file, fIndex) =>
          <FuwfCard
            key={fIndex}
            file={file}
            sending={sending}
            setTab={setTab}
            setFiles={setFiles}
            enableCrop={enableCrop}
            originalFiles={originalFiles}
            setSelectedFileForEdit={setSelectedFileForEdit}
          />
        )}
      </div>

      <FuwfFooter
        setTab={setTab}
        files={files}
        sending={sending}
        setSending={setSending}
        setFiles={setFiles}
        setOpenModal={setOpenModal}
        maxFilesReached={maxFilesReached}
        maxNumberOfUploads={maxNumberOfUploads}
        onUploadComplete={onUploadComplete}
        imageCategory={imageCategory}
        preserveOriginalFile={preserveOriginalFile}
      />
    </div>
  )
}

export default FumFiles
